import { computed } from "vue";
import { useCurrentUser } from "@/composables/useCurrentUser";
import { useCurrentOrganization } from "@/composables/useCurrentOrganization";

/**
 * The club's website CMS URL (MAI-5193), or undefined when the website is off
 * or the URL is blank. Toggle and URL are read from the same org object so an
 * impersonated org never borrows the default org's URL. driveUrl is the
 * optional Google Drive folder for site images, read from that same object.
 */
export function useWebsiteCms() {
  const { currentOrganization } = useCurrentOrganization();
  const { defaultOrganization } = useCurrentUser();

  const org = computed(
    () => currentOrganization.value ?? defaultOrganization.value
  );

  const cmsUrl = computed<string | undefined>(() => {
    if (!org.value?.website_enabled) return undefined;
    return org.value.website_cms_url?.trim() || undefined;
  });

  const driveUrl = computed<string | undefined>(() => {
    if (!org.value?.website_enabled) return undefined;
    return org.value.website_drive_url?.trim() || undefined;
  });

  return { cmsUrl, driveUrl };
}
